function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMapRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.996 9.572c.191 0 .385.028.578.086l6.78 2.057a1.979 1.979 0 001.277-.043l1.717-.652c.188.61.442 1.231.75 1.855l-1.758.667c-.111.042-.227.063-.34.094v13.96l5.628-2.137c.12-.047.248-.07.372-.104v-6.772a47.816 47.816 0 002 2.23v4.518c.104.027.209.043.31.077l5.696 1.92-.004-8.747A39.03 39.03 0 0029 16.007v11.298a2.015 2.015 0 01-1.997 2.024c-.209 0-.423-.034-.636-.105l-5.695-1.92a1.984 1.984 0 00-1.335.024l-6.706 2.543a1.977 1.977 0 01-1.277.044L3.426 27.51A2.02 2.02 0 012 25.572V11.595c0-1.15.931-2.023 1.996-2.023zm.004 16l7 2.143V13.68c-.075-.018-.152-.028-.227-.051l-6.779-2.057.006 14zM23 2a7 7 0 017 7c0 4-7 11-7 11s-7-7-7-11a7 7 0 017-7zm0 2c-2.757 0-5 2.243-5 5 0 1.814 2.595 5.396 5 8.085 2.405-2.689 5-6.271 5-8.085 0-2.757-2.243-5-5-5zm0 2.5a2.5 2.5 0 110 5 2.5 2.5 0 010-5z",
    fill: props.color
  }));
}

export default SvgIconMapRexOutline;